import { IFilter } from '../Tools/IFilter';
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from '../Tools/FiltersController';


export class ShowRSEFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    nbColums?: number;
    controller: FiltersController;
    parentGroup: FilterGroup;
    isFirst: boolean;
    isLast: boolean;

    constructor(parentGroup: FilterGroup, isFirst: boolean, isLast: boolean, nbColumns: number) {
        this.id = 'showRSE';
        this.name = 'RSE';
        this.type = 'showRSE';
        this.isFirst = isFirst;
        this.isLast = isLast;
        this.nbColums = nbColumns;
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = '';
        
        if (this.isFirst) {
            html += '<div class="noPadding" style="display: flex;flex-direction: row; justify-content: space-around;" id="showFilters">'
        }
        html += `
        <div class="${FilterGroup.getColumParam(this.nbColums!)}" style="width: fit-content;height: fit-content;">
            <input id="rseCheckbox" class="btn-default" type="checkbox">
            ${this.name}
        </div>
        `;
        if (this.isLast) {
            html += '</div>';
        }
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            $('#rseCheckbox').prop('checked', FilterGroup.filters.showRSE);
            this.controller.addEventListener('change', () => {
                let val = $('#rseCheckbox').is(':checked');
                FilterGroup.filters.showRSE = val;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'rseCheckbox');
        });
        return html;
    }

    // Done
    generateStringFilter(): string {
        if (!FilterGroup.smartSearch()) {
            if (FilterGroup.filters.showRSE === true) {
                return('&q.rse.eq=true');
            }
        }
        return("");
    }

    destroy(): void {
        this.controller.destroy();
    }

}